import { extendsApp as withApp } from './extends-app'

export { withApp }
